import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { User } from "src/app/models/user-model";
import { AuthService } from "src/app/services/auth/auth.service";
import intlTelInput from "intl-tel-input";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ProfileService } from "src/app/services/profile/profile.service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "src/app/services/user/user.service";
import { Webflow } from "src/app/utils/webflow";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { StripeService } from "src/app/services/stripe/stripe.service";
import { GooglePlaceDirective } from "ngx-google-places-autocomplete";
import { Address } from "ngx-google-places-autocomplete/objects/address";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit, AfterViewInit {
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;

  form!: FormGroup;
  formResetPassword!: FormGroup;
  submitted = false;
  currentUser: any;
  phoneInputElement!: any;
  file!: File;
  image: any;
  loading = true;
  show_reset_password: boolean = false;
  submittedResetPassword = false;
  return_url: string = "";
  existIban: boolean = false;
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private profileService: ProfileService,
    private stripeService: StripeService,
    private activatedRoute: ActivatedRoute,
    public router: Router
  ) {
    this.form = this.formBuilder.group({
      title: ["monsieur", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      full_name: ["", Validators.required],
      address: ["", Validators.required],
      city: ["", Validators.required],
      full_address: ["", Validators.required],
      lat: ["", Validators.required],
      lng: ["", Validators.required],
      country: ["", Validators.required],
      postal_code: ["", Validators.required],
      phone: ["", Validators.required],
      country_phone: [""],
      country_code_phone: [""],
      iban: ["", Validators.required],
    });

    this.formResetPassword = this.formBuilder.group(
      {
        password: ["", [Validators.required, Validators.minLength(6)]],
        passwordConfirmation: [
          "",
          [Validators.required, Validators.minLength(6)],
        ],
      },
      { validators: this.checkPasswords }
    );
  }
  ngAfterViewInit(): void {
    this.initPhone(
      this.currentUser.profile.phone
        ? this.currentUser.profile.country_phone
        : "FR"
    );
    Webflow.setIFrameHeight();
  }

  //validator submit
  get formControl() {
    return this.form.controls;
  }

  get resetPassword() {
    return this.formResetPassword.controls;
  }

  ngOnInit() {
    this.get_init();
  }

  get_init() {
    this.authService.currentUser.subscribe((user) => {
      this.currentUser = User.toJson(
        user,
        this.authService.currentUserValue?.token,
        this.authService.currentUserValue?.is_connect_with,
        this.authService.currentUserValue?.switch_account
      );

      this.existIban =
        user?.profile?.iban != "" &&
        user?.profile?.iban != null &&
        user?.profile?.iban != undefined;

      this.activatedRoute.queryParams.subscribe((params) => {
        this.return_url = params.return ? params.return : "";
        this.show_reset_password = params.form ? true : false;
      });

      console.log("========= this.currentUser ===========");
      console.log(this.currentUser);

      this.form.patchValue(user.profile);
      this.loading = false;
    });
  }

  setupStripeAccount() {
    if (this.existIban) {
      this.spinner.show();
      this.stripeService
        .setupStripeAccount()
        .subscribe(
          (res) => {
            let url = res.url;
            if (url != undefined) {
              window.top.location.href = url;
            } else {
              Swal.fire({
                title: "Erreur",
                text: "Une érreur est survenue",
                icon: "error",
                position: "top",
              });
            }
          },
          (error) => {
            if (GenerateErrors.check_if_is_custom_error(error)) {
              Swal.fire({
                title: "Érreur",
                text: GenerateErrors.get_message_error(error),
                icon: "error",
                position: "top",
              });
            } else {
              Swal.fire({
                title: "Erreur",
                text: "Une érreur est survenue",
                icon: "error",
                position: "top",
              });
            }
          }
        )
        .add(() => {
          Webflow.setIFrameHeight();
          this.spinner.hide();
        });
    } else {
      Webflow.setIFrameHeight();
      Swal.fire({
        title: "Attention",
        text: "Veuillez d'abord entrer l'IBAN et modifier le profil avant de vérifier votre compte.",
        icon: "info",
        position: "top",
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      Webflow.setIFrameHeight();
      Swal.fire({
        title: "Erreur",
        text: "Veuillez remplir les champs requis.",
        icon: "error",
        position: "top",
      });
      return;
    }

    if (this.form.value.phone.replace(/\s+/g, "").length != 9) {
      Swal.fire({
        title: "Attention",
        text: "Veuillez vérifier votre numéro de téléphone",
        icon: "info",
        position: "top",
      });
      return;
    }

    // send phone data
    const countryData = this.phoneInputElement.getSelectedCountryData();
    this.form.patchValue({
      phone: this.form.value.phone.replace(/\s+/g, ""),
      country_phone: countryData.iso2,
      country_code_phone: "+" + countryData.dialCode,
      postal_code: this.form.value.postal_code.toString(),
    });

    if (
      !this.existIban &&
      this.currentUser.switch_account == "manager_studio" &&
      this.form.value.iban == ""
    ) {
      Webflow.setIFrameHeight();
      Swal.fire({
        title: "Erreur",
        text: "Veuillez saisir l'IBAN",
        icon: "error",
        position: "top",
      });
      return;
    }

    var obj = this.form.value;

    obj.iban = obj.iban.replace(/\s+/g, "");

    if (this.currentUser.switch_account == "artist") {
      delete obj.iban;
    }

    this.spinner.show();

    var is_connect_with = this.authService.currentUserValue.is_connect_with;
    var switch_account = this.authService.currentUserValue.switch_account;

    obj["is_connect_with"] = is_connect_with;

    this.profileService
      .update(
        this.currentUser.profile.id,
        obj,
        this.file,
        this.authService.currentUserValue.token
      )
      .subscribe(
        (res) => {
          this.currentUser = {
            ...this.currentUser,
            profile: {
              ...this.currentUser.profile,
              ...res["data"]["attributes"],
            },
          };

          if (is_connect_with) {
            this.userService
              .getById(
                this.authService.currentUserValue.id,
                this.authService.currentUserValue.token
              )
              .subscribe(
                (user) => {
                  let userJson = User.toJson(
                    user,
                    this.authService.currentUserValue.token,
                    is_connect_with,
                    switch_account
                  );
                  if (userJson != null) {
                    localStorage.setItem(
                      "studiomapUser",
                      JSON.stringify(userJson)
                    );
                    this.authService.callCurrentUserSubject(userJson);
                  } else {
                    this.authService.logout();
                  }
                },
                (err) => {
                  this.authService.logout();
                }
              );
          } else {
            this.userService
              .get(this.authService.currentUserValue.token)
              .subscribe(
                (user) => {
                  let userJson = User.toJson(
                    user,
                    this.authService.currentUserValue.token,
                    is_connect_with,
                    switch_account
                  );
                  if (userJson != null) {
                    localStorage.setItem(
                      "studiomapUser",
                      JSON.stringify(userJson)
                    );
                    this.authService.callCurrentUserSubject(userJson);
                  } else {
                    this.authService.logout();
                  }
                },
                (err) => {
                  this.authService.logout();
                }
              );
          }

          this.activatedRoute.queryParams.subscribe((params) => {
            if (params.return && params.return.includes("tarifications")) {
              Swal.fire({
                title: "Quitter cette page ?",
                html: "<p>Félicitation ! Profile modifié avec succès</p><p>Êtes-vous sûr de vouloir retourner à la page précédente ?</p>",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: `Page précédente`,
                cancelButtonText: `Rester sur la page`,
                position: "top",
                cancelButtonColor: "black",
                confirmButtonColor: "#D63333",
              }).then((result) => {
                if (result.isConfirmed) {
                  Webflow.myAction(this.router, params.return, {});
                }
              });
            } else {
              Swal.fire({
                title: "Félicitation",
                text: "Profile modifié avec succès",
                icon: "success",
                position: "top",
              });
              this.redirectAfterUpdate();
            }
          });
        },
        (error) => {
          if (GenerateErrors.check_if_is_custom_error(error)) {
            Swal.fire({
              title: "Érreur",
              text: GenerateErrors.get_message_error(error),
              icon: "error",
              position: "top",
            });
          } else {
            Swal.fire({
              title: "Erreur",
              text: "Une érreur est survenue",
              icon: "error",
              position: "top",
            });
          }
        }
      )
      .add(() => {
        Webflow.setIFrameHeight();
        this.spinner.hide();
        this.submitted = false;
      });
  }

  onReset() {
    this.submittedResetPassword = true;
    if (this.formResetPassword.invalid) {
      Webflow.setIFrameHeight();
      if (this.formResetPassword.controls["password"].errors?.required) {
        Swal.fire({
          title: "Erreur",
          text: 'Le champ "Mot de passe" est requis',
          icon: "error",
          position: "top",
        });
      } else if (
        this.formResetPassword.controls["password"].errors?.minlength
      ) {
        Swal.fire({
          title: "Erreur",
          text: "Le mot de passe doit contenir au moins 6 caractères",
          icon: "error",
          position: "top",
        });
      } else if (
        this.formResetPassword.controls["passwordConfirmation"].errors?.required
      ) {
        Swal.fire({
          title: "Erreur",
          text: 'Le champ "Confirmez votre mot de passe" est requis',
          icon: "error",
          position: "top",
        });
      } else if (
        this.formResetPassword.value.password !==
        this.formResetPassword.value.passwordConfirmation
      ) {
        Swal.fire({
          title: "Erreur",
          text: "Les mots de passe ne correspondent pas",
          icon: "error",
          position: "top",
        });
      } else {
        Swal.fire({
          title: "Erreur",
          text: "Veuillez vérifier vos informations",
          icon: "error",
          position: "top",
        });
      }
      return;
    }

    this.spinner.show();
    this.userService
      .change_password(this.formResetPassword.value)
      .subscribe(
        (res) => {
          Swal.fire(
            "Félicitation",
            "Mot de passe modifié avec succès",
            "success"
          );
          this.formResetPassword.reset();
          this.redirectAfterUpdate();
        },
        (error) => {
          if (GenerateErrors.check_if_is_custom_error(error)) {
            Swal.fire({
              title: "Érreur",
              text: GenerateErrors.get_message_error(error),
              icon: "error",
              position: "top",
            });
          } else {
            Swal.fire({
              title: "Erreur",
              text: "Une érreur est survenue",
              icon: "error",
              position: "top",
            });
          }
        }
      )
      .add(() => {
        Webflow.setIFrameHeight();
        this.spinner.hide();
        this.submittedResetPassword = false;
      });
  }

  checkPasswords(group: FormGroup) {
    // here we have the 'passwords' group
    const password = group.get("password")?.value;
    const passwordConfirmation = group.get("passwordConfirmation")?.value;
    return password === passwordConfirmation ? null : { notSame: true };
  }

  initPhone(countryCode: string) {
    const inputElement = document.getElementById("phone");
    if (inputElement) {
      this.phoneInputElement = intlTelInput(inputElement as HTMLInputElement, {
        initialCountry: countryCode,
        separateDialCode: true,
      });
    }
  }

  uploadFile(event: any) {
    var reader = new FileReader();
    this.file = event.target.files[0];
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = () => {
      if (img.width < 200 || img.height < 200) {
        Webflow.setIFrameHeight();
        Swal.fire({
          title: "Erreur",
          text: "L'image téléchargée est trop petite. La taille d'image minimale est 200x200px. Veuillez télécharger une image plus grande",
          icon: "error",
          position: "top",
        });
        return;
      } else {
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.image = reader.result;
        };
      }
    };
  }

  redirectAfterUpdate() {
    if (this.return_url != "") {
      let my_params = {};
      this.activatedRoute.queryParams.subscribe((params) => {
        my_params = { ...params }; // Create a shallow copy of params
      });

      delete my_params["return"];
      delete my_params["form"];

      Webflow.myAction(this.router, this.return_url, my_params);
    } else {
      this.get_init();
      //window.location.reload();
      //Webflow.myAction(this.router, "dashboard", {});
    }
  }

  handleAddressChange(place: Address) {
    console.log("*********** place.address_components ***********");

    console.log(place.address_components);

    // Extract latitude and longitude
    const latitude = place.geometry.location.lat();
    const longitude = place.geometry.location.lng();

    let city: string = "";
    let country: string = "";
    let short_address: string = "";
    let postal_code = "";

    place.address_components.filter((component: any) => {
      switch (component.types[0]) {
        case "locality":
          city = component.long_name;
          return true;
        case "postal_code":
          postal_code = component.long_name;
          return true;
        case "street_number":
          short_address = short_address + component.long_name;
          return true;
        case "route":
          short_address = short_address + " " + component.long_name;
          return true;
        case "country":
          country = component.long_name;
          return true;
        default:
          return false;
      }
    });
    this.form.controls?.full_address?.setValue(place.formatted_address);
    this.form.controls?.city?.setValue(city);
    this.form.controls?.country?.setValue(country);
    this.form.controls?.address?.setValue(short_address);
    this.form.controls?.postal_code?.setValue(postal_code.toString());
    this.form.controls?.lat?.setValue(latitude.toString());
    this.form.controls?.lng?.setValue(longitude.toString());
  }
}
